const clinictariff = {
    getlist: 'clinictariff/getlist',
    add: 'clinictariff/add',
    update: 'clinictariff/update',
    remove: 'clinictariff/remove',
    get: 'clinictariff/get',
    getall: 'clinictariff/getall',
    clearcache: 'clinictariff/clear-cache',
}
export default clinictariff
